export default "__VITE_ASSET__6WnXUy18__"